import React, { Component } from "react";
import { Menu } from 'antd';
import { withRouter } from 'react-router';

import '../../assets/css/admin.less'

/**
 * 问题左侧路由组件
 */
class LeftQue extends Component {


    handleClick= (e)=> {
        switch (e.key) {
            case '1':
                this.props.history.push("/question");
                break;
            case '2':
                this.props.history.push("/ask");
                break;
            case '3':
                this.props.history.push("/mine");
                break;
        }
    };

    render (){
        return (
            <div className="left">
                <Menu style={{ width: 210 }} defaultSelectedKeys={['1']} defaultOpenKeys={['sub1']}>
                    <Menu.Item key="1" onClick={this.handleClick.bind(this)}>
                        问题讨论
                    </Menu.Item>
                    <Menu.Item key="2" onClick={this.handleClick.bind(this)}>
                        问题提问
                    </Menu.Item>
                    <Menu.Item key="3" onClick={this.handleClick.bind(this)}>
                        我的问题
                    </Menu.Item>
                </Menu>
            </div>
        )
    }
}

export default withRouter(LeftQue);